// extracted by mini-css-extract-plugin
export var prixClipFix = "SpinnerLoader-module--prixClipFix--d2c10";
export var rotate = "SpinnerLoader-module--rotate--50795";
export var spinnerLoader = "SpinnerLoader-module--spinnerLoader--62621";